import React from 'react';
import Image, { StaticImageData } from 'next/image';

import { ArrowLinkProps } from 'Elements/Link/Arrow';

import defaultProfileImage from 'Public/images/cards/profile/default.png';

import {
    ImageWrapper,
    Container,
    Quote,
    StudentContainer,
    Avatar,
    ResponsiveLinkWrapper,
    BioContainer,
    Hr,
    Heading,
    Position,
    Organisation,
    DetailsContainer,
    LinkWrapper,
    Link
} from './Profile.styled';

export interface Props {
    quote: string;
    name: string;
    position?: string;
    organisation?: string;
    featureImage: {
        src: StaticImageData | string;
    };
    avatar?: {
        src: StaticImageData | string;
        alt?: string;
    };
    link: ArrowLinkProps;
}

const Profile: React.FC<Props> = ({
    featureImage,
    avatar,
    quote,
    name,
    position,
    organisation,
    link
}) => {
    return (
        <Container>
            <ImageWrapper>
                <Image
                    src={`${featureImage.src}`}
                    alt=""
                    fill
                    style={{ objectFit: 'cover' }}
                    quality={100}
                />
            </ImageWrapper>
            <StudentContainer>
                <Quote>“{quote}”</Quote>
                <Hr />
                <BioContainer>
                    <DetailsContainer>
                        <Avatar>
                            <Image
                                src={avatar?.src || defaultProfileImage}
                                alt={avatar?.alt ? avatar.alt : ''}
                                fill
                                style={{ objectFit: 'cover' }}
                            />
                        </Avatar>
                        <div>
                            <Heading>{name}</Heading>
                            {position && <Position>{position}</Position>}
                            {organisation && <Organisation>{organisation}</Organisation>}
                            <ResponsiveLinkWrapper>
                                <Link {...link} iconOutline iconBorder={false} />
                            </ResponsiveLinkWrapper>
                        </div>
                    </DetailsContainer>
                    <LinkWrapper>
                        <Link {...link} iconOutline iconBorder={false} />
                    </LinkWrapper>
                </BioContainer>
            </StudentContainer>
        </Container>
    );
};

export default Profile;
